export const AnchorReveal = ({ anchor }: { anchor: string }) => (
  <a href={`#${anchor}`} className="anchor-reveal">
    #
  </a>
)
